import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { AppLayout } from "../layouts";
import { Cards, Header, SelectO, Sides } from "../components";
import { Col, Container, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

const DashboardCommonPage = ({ loginData, overView, rightSide1 }) => {
    const navigate = useNavigate();
    const patient_access = JSON.parse(localStorage.getItem("patient_access"));
    const doctor_access = JSON.parse(localStorage.getItem("doctor_access"));
    const admin_access = JSON.parse(localStorage.getItem("admin_access"));

    const [options, setOptions] = useState([]);
    const [selectedLanguages, setSelectedLanguages] = useState(null);


    const { i18n } = useTranslation();
    const { t } = useTranslation();

    const getLanguagesData = useSelector(
        (state) => state.common.getLanguagesData?.data
    );

    useEffect(() => {
        if (getLanguagesData) {
            const newOption = getLanguagesData.result
                .filter((item) => item.isWebsiteLanguage === true)
                .map((item) => ({
                    value: item.languageId,
                    label: item.languageName,
                    abb: item.languageAbbreviation,
                }));

            setOptions(newOption);
        }
    }, [getLanguagesData]);

    useEffect(() => {
        const storedLanguage = JSON.parse(localStorage.getItem("doctor_access"));
        if (storedLanguage && storedLanguage.languageId) {
            const savedLang = options.find(option => option.value === storedLanguage.languageId);
            if (savedLang) {
                setSelectedLanguages(savedLang);
                i18n.changeLanguage(savedLang.abb);
            }
        }
    }, [options, i18n]);

    useEffect(() => {
        if (doctor_access && doctor_access.userType === loginData.userType) {
            const selectedLanguage = options.find(option => option.value === doctor_access.languageId);
            if (selectedLanguage && selectedLanguage.value !== selectedLanguages?.value) {
                setSelectedLanguages(selectedLanguage);
                i18n.changeLanguage(selectedLanguage.abb);
                localStorage.setItem("doctor_access", JSON.stringify(doctor_access));
            }
        }
    }, [doctor_access, loginData, options, selectedLanguages, i18n]);

    const handleSelectChange = (selected) => {
        setSelectedLanguages(selected);
        i18n.changeLanguage(selected.abb);

        if (doctor_access && doctor_access.userType === loginData.userType) {
            const updatedDoctorAccess = { ...doctor_access, languageId: selected.value, languageAbb: selected.abb };
            localStorage.setItem("doctor_access", JSON.stringify(updatedDoctorAccess));
        }
    };

    const buttons = (
        <>
            {
                loginData?.userType === 1 ? (
                    <SelectO.SelectO
                        options={options}
                        onChange={handleSelectChange}
                        className="select0"
                        isSearchable={false}
                        value={selectedLanguages}
                        formatOptionLabel={(option, { context }) =>
                            context === "value" ? option.label.slice(0, 3) : option.label
                        }
                    />
                )
                    :
                    ""
            }

        </>
    );

    const rightSide = (
        <Container fluid className="exado-container1">
            <Row className="exado-row1">
                <Col>
                    {
                        loginData?.userType === 1 ? (
                            <Header.HeadingPage pageHeading={t("dashboard")} buttons={buttons} />
                        )
                            : loginData?.userType === 2 ? (
                                <Header.HeadingPage1 pageHeading={t("dashboard")} />
                            ) : ""
                    }

                </Col>
            </Row>
            {overView?.length > 0 ? (<Row className="exado-row1">

                <Col md={12}>
                    <h2 className="exado-title-nine">{t("monthly-overview")}</h2>
                    <p className="exado-title-three ">
                        {t("doctor.dashboard.monthly_overview_subtitle")}
                    </p>
                </Col>
                {overView.map((item, index) => (
                    <Col key={index} lg={3} md={6} className="dashboard-overview-col">
                        <Cards.Cardd
                            className="cardd custom-cursor-pointer "
                            header={item.header}
                            title={item.title}
                            content={item.content}
                            onClick={() => navigate(item?.to)}
                        />
                    </Col>
                ))}
            </Row>) : ""}

            {rightSide1}
        </Container>
    );

    return (
        <>
            <AppLayout.AppLayoutOne
                leftSide={<Sides.LeftSides loginData={loginData} />}
                rightSide={rightSide}
            />
        </>
    );
};

export default DashboardCommonPage;
